import {
  WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_BY_TOOL,
  WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_WHEN,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentCacheInvalidationFlushWhen';

export const shouldFlushWorkspaceAgentCacheInvalidationOnToolResult = (toolName: string | undefined): boolean => {
  if (!toolName) {
    return false;
  }

  return Object.entries(WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_BY_TOOL).some(
    ([configuredToolName, config]) =>
      configuredToolName === toolName && config.flushWhen === WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_WHEN.TOOL_RESULT,
  );
};
